<mdc-dialog-title>User Info</mdc-dialog-title>
<mdc-dialog-content>
    <mdc-card outlined>

        <!-- Section: Mode-Specific Instructions -->
        <section
            style="background: #f9f9fb; padding: 16px; border-radius: 12px; box-shadow: 0 2px 6px rgba(0,0,0,0.08); margin-bottom: 24px;">
            <h2 style="margin-top: 0; font-size: 1.25rem; border-bottom: 2px solid #ccc; padding-bottom: 6px;">🧭
                Mode-Specific Information</h2>

            <!-- Selection Mode -->
            <div show.bind="globalStateObject.activeState === selectionMode" style="margin-bottom: 16px;">
                <h3><strong>🎯 Selection Mode</strong></h3>
                <p>Drag and resize instances in the scene. Click an instance to select it.</p>
                <ul>
                    <li><strong>Left-click:</strong> Drag the object</li>
                    <li><strong>Right-click:</strong> Scale the object</li>
                    <li><strong>Middle-click:</strong> Rotate (3D view only)</li>
                    <li>Use UI handles or arrow keys to adjust the object</li>
                    <li>Click or right-click empty canvas to exit</li>
                </ul>
            </div>

            <!-- Drawing Mode -->
            <div show.bind="globalStateObject.activeState === drawingMode" style="margin-bottom: 16px;">
                <h3><strong>✏️ Drawing Mode</strong></h3>
                <p>Select a class in the left panel, then click on an empty canvas area to add it.</p>
                <p>To draw a relationclass, select one from the panel.</p>
            </div>

            <!-- Drawing Mode Relationclass -->
            <div show.bind="globalStateObject.activeState === drawingModeRelationClass" style="margin-bottom: 16px;">
                <h3><strong>🔗 Relation Drawing Mode</strong></h3>
                <p>Select a relationclass, then click on a class instance to draw a relation.</p>
                <p>To go back to class drawing, just select a class from the panel.</p>
            </div>

            <!-- View Mode -->
            <div show.bind="globalStateObject.activeState === viewMode" style="margin-bottom: 16px;">
                <h3><strong>👁️ View Mode</strong></h3>
                <p>No class or relationclass selected.</p>
                <ul>
                    <li>Select a class → <strong>Drawing Mode</strong></li>
                    <li>Select a relationclass → <strong>Relation Drawing Mode</strong></li>
                    <li>Click an instance → <strong>Selection Mode</strong></li>
                </ul>
            </div>

            <!-- Simulation Mode -->
            <div show.bind="globalStateObject.activeState === simulationMode">
                <h3><strong>🚀 Simulation Mode</strong></h3>
                <p>Click on a simulation button in the model to trigger its behavior.</p>
            </div>
        </section>

        <!-- General Info Section -->
        <mdc-list-divider></mdc-list-divider>

        <section style="margin-top: 24px;">
            <mdc-expandable>
                <div au-slot="caption">
                    <!-- 2D/3D Mode -->
                    <h3><strong>🔄 2D/3D Mode</strong></h3>
                </div>
                <ul>
                    <li>🔛 Switch between 2D and 3D views using the toggle slider in the tools menu.</li>
                </ul>
            </mdc-expandable>
            <mdc-expandable>
                <div au-slot="caption">
                    <h3><strong>📦 Create or Load Scene Instance</strong></h3>
                </div>
                <ul>
                    <li>Select a SceneType from the left panel and click <strong>Create New SceneInstance</strong>, or
                        double-click its name.</li>
                    <li>To load an existing one, expand a SceneType and double-click the desired instance.</li>
                </ul>
            </mdc-expandable>

            <mdc-expandable accordion>
                <div au-slot="caption">
                    <h3><strong>💾 Save, Download, and Import</strong></h3>
                </div>
                <ul>
                    <li><strong>File → Save Model:</strong> Save current scene</li>
                    <li><strong>File → Export Model as .json:</strong> Download your scene</li>
                    <li><strong>File → Import Model:</strong> Load a saved scene</li>
                </ul>
            </mdc-expandable>
            <mdc-expandable>
                <div au-slot="caption">
                    <h3><strong>🧰 General Actions</strong></h3>
                </div>
                <ul>
                    <li><strong>Zoom:</strong> Use mouse wheel or touchpad</li>
                    <li><strong>Move:</strong> Right-click and drag to pan</li>
                    <li><strong>Rotate:</strong> Middle-click and drag (3D only)</li>
                    <li><strong>2D/3D View:</strong> Use the view toggle slider</li>
                    <li><strong>Autosave:</strong> Use the autosave toggle slider to activate or deactivate autosave to the DB</li>
                </ul>
            </mdc-expandable>
        </section>

    </mdc-card>
</mdc-dialog-content>

<mdc-dialog-actions>
    <button mdc-button data-mdc-dialog-action="cancel" click.trigger="cancel()">Cancel</button>
    <button mdc-button data-mdc-dialog-action="reportProblem" click.trigger="reportProblem()">Report Problem</button>
</mdc-dialog-actions>